import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { getCookieValue } from "../../utils/cookies/getCookieValue.esm.js";
const GoogleForm = ({
  formId,
  zuidFieldName,
  width = 640,
  height = 586
}) => {
  const [iframeUrl, setIframeUrl] = useState("");
  useEffect(() => {
    const userId = getCookieValue("zjs_user_id") !== null ? getCookieValue("zjs_user_id").replace(/[^A-Za-z0-9\-_]/g, "") : "";
    const baseUrl = `https://docs.google.com/forms/d/e/${formId}/viewform`;
    const params = new URLSearchParams({
      embedded: "true",
      ...userId && {
        [zuidFieldName]: userId
      }
    });
    setIframeUrl(`${baseUrl}?${params.toString()}`);
  }, [formId, zuidFieldName]);
  if (!iframeUrl) {
    return /* @__PURE__ */ jsx("div", { children: "Loading form..." });
  }
  return /* @__PURE__ */ jsx("iframe", { src: iframeUrl, width, height, frameBorder: "0", marginHeight: "0", marginWidth: "0", title: "Google Form", children: "Loading…" });
};
GoogleForm.propTypes = {
  formId: PropTypes.string.isRequired,
  zuidFieldName: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export {
  GoogleForm as default
};
